"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var use_toggle_state_hook_1 = __importDefault(require("../../hooks/use-toggle-state.hook"));

var Menu_1 = __importDefault(require("@material-ui/core/Menu"));

var variable_insert_button_styles_1 = require("./variable-insert-button.styles");

var VariableInsertButton = function VariableInsertButton(_ref) {
  var variables = _ref.variables,
      onVariableClick = _ref.onVariableClick;
  var buttonRef = react_1.useRef(null);

  var _use_toggle_state_hoo = use_toggle_state_hook_1.default(),
      isOpen = _use_toggle_state_hoo.state,
      handleOff = _use_toggle_state_hoo.handleOff,
      handleOn = _use_toggle_state_hoo.handleOn;

  var handleMenuItemClick = function handleMenuItemClick(variable) {
    return function () {
      onVariableClick(variable);
      handleOff();
    };
  };

  return react_1.default.createElement("div", null, react_1.default.createElement(variable_insert_button_styles_1.StyledButton, {
    ref: buttonRef,
    variant: "outlined",
    color: "default",
    onClick: handleOn
  }, "\u5909\u6570\u3092\u8FFD\u52A0"), react_1.default.createElement(Menu_1.default, {
    id: "simple-menu",
    anchorEl: buttonRef.current,
    keepMounted: true,
    open: isOpen,
    onClose: handleOff
  }, variables.map(function (variable) {
    return react_1.default.createElement(variable_insert_button_styles_1.StyledMenuItem, {
      onClick: handleMenuItemClick(variable),
      key: variable.key
    }, variable.label);
  })));
};

exports.default = VariableInsertButton;